import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Select from 'react-select'
import { Toast } from "react-bootstrap";
import { all_routes } from "../../../../../router/all_routes";
import { useUserPermissions } from "../../../../../UserPermissionsContext";
import DualListBox from "../../../../../duallistBox";
import { set } from "date-fns";
import { te } from "date-fns/locale";

type DualList = { id: number; name: string };

interface TeamType {
  id: number;
  name: string;
}

interface TeamLead {
  id: number;
  display_name: string;
}

type Admin = {
  permissions: Array<number>;
  name: string | null;

  id: number;
};

interface Option {
  value: number;
  label: string;
}

interface ErrorMessages {
  name?: string[];
}


const AddPrismTeamManagement = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [chosenTeamLeads, setChosenTeamLeads] = useState<DualList[]>([]);
  const [chosenTeamMembers, setChosenTeamMembers] = useState<DualList[]>([]);
  // const [permissions, setPermissions] = useState<Permission[]>([]);
  const [teamType, setTeamType] = useState<TeamType[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [selectedTeamType, setSelectedTeamType] = useState<Option | null>(null);
  const [teamName, setTeamName] = useState<string>("");
  const [teamLeads, setTeamLeads] = useState<DualList[]>([]);
  const [teamMembers, setTeamMembers] = useState<DualList[]>([]);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    if ((showSolidDangerToast || showSolidSuccessToast) === true) {
      setTimeout(() => setShowSolidDangerToast(false), 5000);
      setTimeout(() => setshowSolidSuccessToast(false), 5000);
    }
  }, [toastMessage])
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  useEffect(() => {
    // both empty → clear
    if (!selectedTeamType && chosenTeamLeads.length === 0) {
      setTeamMembers([]);
      return;
    }

    // one missing → do nothing
    if (!selectedTeamType || chosenTeamLeads.length === 0) {
      return;
    }

    // both present → fetch
    fetchTeamMembers(
      selectedTeamType.value,
      chosenTeamLeads.map(l => l.id)
    );
  }, [selectedTeamType, chosenTeamLeads]);

  const teamTypeOptions: Option[] = teamType.map(user => ({
    value: user.id,
    label: user.name,
  }));

  const handleTeamTypeChange = (option: Option | null) => {
    setSelectedTeamType(option);
    if (option) {
      console.log('Selected ID:', option.value);
    }
  };


  const handleTeamLeadsChange = (selected: DualList[]) => {
    setChosenTeamLeads(selected);
  };

  const handleTeamMembersChange = (selected: DualList[]) => {
    setChosenTeamMembers(selected);
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchTeamtype = async () => {
    const resposne = await fetch(`${webApi}/school_leads/school_leads_team_types_for_team_mgmt_oprations/?building_category=3`, options);
    return await resposne.json();
  };

  const fetchTeamLeads = async () => {
    const resposne = await fetch(`${webApi}/school_leads/user_dropdown_for_team_leads_to_create_school_lead_team/`, options);
    if (!resposne.ok) {
      const errorData = await resposne.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    const data = await resposne.json();
    const mapped: DualList[] = data.map((item: any) => ({
      id: item.id,
      name: item.display_name,
    }));
    setTeamLeads(mapped);
  };

  const fetchTeamMembers = async (teamType: number, leadIds: number[]) => {
    const ids = leadIds.join(",");

    const response = await fetch(
      `${webApi}/school_leads/user_dropdown_for_team_members_to_create_school_lead_team/?team_type=${teamType}&lead_ids=${ids}`,
      options
    );

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }

    const data = await response.json();

    const mapped: DualList[] = data.map((item: any) => ({
      id: item.id,
      name: item.display_name,
    }));

    setTeamMembers(mapped);
  };


  const fetchData = async () => {
    setIsLoading(true); // Start loading
    try {
      const [permissionsData] = await Promise.all([fetchTeamtype()]);

      // Convert the fetched data to the Permission type
      const formattedPermissions = permissionsData.map(
        (permission: { id: number; name: string }): DualList => ({
          id: permission.id,
          name: permission.name,
        })
      );

      setTeamType(formattedPermissions);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (!checkPermission("add_schoolleadteammgmt", "schoolleadteammgmt")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
      fetchTeamLeads();
    }
  }, [userPermissions]);

  const updateData = async () => {
    const newTeam = {
      name: teamName,
      team_type: selectedTeamType ? selectedTeamType.value : null,
      team_leads: chosenTeamLeads.map(permission => permission.id),
      team_members: chosenTeamMembers.map(permission => permission.id),
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newTeam),
    };
    const url = `${webApi}/school_leads/school_lead_team_mgmt/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      setErrorMessage(errorData);
      setToastMessage(errorData.name);
      if (toastMessage !== "") {
        setShowSolidDangerToast(true);
      }
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await updateData();
      navigate(routes.prismTeamManagement);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTeamName(e.target.value);
  };

  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Add Team</h3>
                <ul className="breadcrumb">
                  {/* <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li> */}
                  <li className="breadcrumb-item">
                    <Link to={routes.prismTeamManagement}>
                      Team Management List
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Add Team</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add Group */}
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div
                      className="form-group mb-3"
                      style={{
                        width: "70%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "28%" }}>
                        <label className="form-label">Team Name</label>
                        <input
                          type="text"
                          className={`form-control ${errorMessage.name ? "is-invalid" : ""
                            }`}
                          name="name"
                          placeholder="Team Name"
                          onChange={handleInputChange}
                          value={teamName}
                          required
                        />
                        {errorMessage.name && (
                          <div className="invalid-feedback">
                            {errorMessage.name[0]}
                          </div>
                        )}
                      </div>
                      <div style={{ width: "28%" }}>
                        <label className="form-label">Team Type</label>
                        <Select
                          value={selectedTeamType}
                          onChange={handleTeamTypeChange}
                          options={teamTypeOptions}
                          placeholder="Select a team Type"
                          required
                        />
                      </div>
                    </div>

                    <div className="form-group dual-list-box-container">
                      <label className="form-label">Team Lead</label>
                      <DualListBox
                        options={teamLeads}
                        selected={chosenTeamLeads}
                        onChange={handleTeamLeadsChange}
                      />
                    </div>
                    <div className="form-group dual-list-box-container">
                      <label className="form-label">Team Members</label>
                      <DualListBox
                        options={teamMembers}
                        selected={chosenTeamMembers}
                        onChange={handleTeamMembersChange}
                      />
                    </div>
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.prismTeamManagement}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
    </div>
  );
};

export default AddPrismTeamManagement;
